import './style.css';
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import {App} from './app';

const root = ReactDOM.createRoot(document.body);
root.render(React.createElement(App));
